module.exports = __webpack_public_path__ + "img/destinataires.d62f2791.jpg";